import createStore, { history } from './createStore';

const store = createStore();

export { store, history };
